import React from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { Row } from "react-flexbox-grid";
import {
  Card,
  CardContent,
  CardActions,
  CardHeader,
  LinearProgress,
  Button,
  Typography
} from "@material-ui/core";
import Save from "@material-ui/icons/Save";

import CastsInFileTable from "./CastsInFileTable";

const styles = {
  yellowBackground: {
    display: "inline",
    backgroundColor: "hsl(40, 100%, 93%)",
    lineHeight: "175%"
  },
  redBackground: {
    display: "inline",
    backgroundColor: "hsl(359, 87%, 93%)",
    lineHeight: "175%"
  },
  orangeBackground: {
    display: "inline",
    backgroundColor: "#ffe1cc",
    lightHeight: "175%"
  }
};

const CastsInFileCard = props => (
  <Card>
    <CardHeader title="Casts in selected files" />
    <CardContent>
      <Typography component="p" style={{ marginBottom: 10 }}>
        Note that casts are ordered by time to make it easier to check the casts
        one drop at a time. However, this mixes up the casts from each file. The
        software annotates an entire file at once, so if one cast is not
        correct, please make sure you remove the entire file before annotating.
      </Typography>
      {props.soloCastsFetching && (
        <LinearProgress style={{ marginBottom: 10 }} />
      )}
      <Row center="xs">
        <ContainerDimensions>
          <CastsInFileTable {...props} />
        </ContainerDimensions>
      </Row>
      <Typography style={styles.yellowBackground}>
        Yellow warning: Form/instrument difference of 5-8 min or 5-10 metres
      </Typography>
      <br />
      <Typography style={styles.redBackground}>
        Red warning: Form/instrument difference of 8+ min or 10+ metres
      </Typography>
      <br />
      <Typography style={styles.orangeBackground}>
        Orange warning: the same form has been used to annotate more than one
        cast. Please either change the form or mark the extra cast(s) as
        miscast.
      </Typography>
    </CardContent>
    <CardActions>
      <Button
        variant="contained"
        color="primary"
        disabled={
          props.soloCastsFetching ||
          props.soloSavingFiles ||
          props.soloDuplicateFormsInCastsBeingAnnotated.length > 0
        }
        onClick={props.onAnnotateFileClick}
        style={{ marginLeft: "auto" }}
      >
        Save Annotations
        <Save />
      </Button>
    </CardActions>
  </Card>
);

CastsInFileCard.propTypes = {
  soloCastsFetching: PropTypes.bool,
  soloSavingFiles: PropTypes.bool.isRequired,
  onAnnotateFileClick: PropTypes.func.isRequired,
  soloDuplicateFormsInCastsBeingAnnotated: PropTypes.arrayOf(PropTypes.number)
    .isRequired
};

CastsInFileCard.defaultProps = {
  soloCastsFetching: false
};

export default CastsInFileCard;
